import React from "react"
import { Route, Redirect } from "react-router-dom"
import Auth from "./Auth"

class CustomerRoute extends React.Component {
  state = {
    auth: false,
    loading: true,
    error: "",
  }

  async componentDidMount() {
    const response = await Auth.tokenCheck("customer")
    if (response.authenticated) {
      this.setState({ auth: true })
    }
    else {
      Auth.logout();
    }
    this.setState({ error: response.error })
    this.setState({ loading: false })
  }

  async componentDidUpdate(prevProps) {
    // check for a new location change
    if (this.props.location !== prevProps.location) {
      const response = await Auth.tokenCheck("customer")
      if (response.authenticated) {
        this.setState({ auth: true })
      }
      else {
        Auth.logout()
        this.setState({ auth: false })
      }
      this.setState({ error: response.error })
      this.setState({ loading: false })
    }
  }

  render() {
    const { loading, auth } = this.state
    if (!loading && !auth) {
      let hash = window?.location?.hash ? window?.location?.hash: '';
      localStorage.setItem('path', window?.location?.pathname + hash)
      return (
        <Redirect
          to={{
            pathname: "/LoginAsInstitution",
            state: {
              error: this.state.error,
            },
          }}
        />
      )
    } else {
      return (
        !loading && (
          (this.props.component) ?
          <Route
            exact={this.props.exact}
            path={this.props.path}
            component={this.props.component}
          /> :
          <Route
            exact={this.props.exact}
            path={this.props.path}
            render={this.props.render}
          />
        )
      )
    }
  }
}

export default CustomerRoute
